import { buildNewUrl } from "features/routing";

const shouldHavePreviousPage = (currentPage) => currentPage > 1; 
const shouldHaveNextPage = (currentPage, lastPage) => currentPage < lastPage; 

/**
 * getNextPageUrl: Gets the url for the Next Page Link Element.
 * @param {Object} paging Object with the information related to the pages. It includes the current and last page.
 * @param {Object} nextPageUrlConfig Object with the information related to the section for the url.
 * @returns An string with the url that is going to be used for the Next Page Link Element.
 */
export const getNextPageUrl = (paging, nextPageUrlConfig) => {
  const { currentPage, lastPage } = paging;
  const hasNextPage = shouldHaveNextPage(currentPage, lastPage);

  return hasNextPage ? buildNewUrl(nextPageUrlConfig) : '';
}

/**
 * getPreviousPageUrl: Gets the url for the Previous Page Link Element.
 * @param {Number} currentPage Number of the current page of the search.
 * @param {Object} previousPageUrlConfig Object with the information related to the sections for the url.
 * @returns An string with the url that is going to be used for the Previous Page Link Element.
 */
export const getPreviousPageUrl = (currentPage, previousPageUrlConfig) => {
  const hasPreviousPage = shouldHavePreviousPage(currentPage);

  return hasPreviousPage ? buildNewUrl(previousPageUrlConfig) : '';
}

/**
 * Takes in search location parameters and returns a string of map coordinates in a specific
 * format as a querystring value.
 * @param locationParameters - `locationParameters` is an object that contains four properties:
 * `minimumLatitude`, `maximumLatitude`, `minimumLongitude`, and `maximumLongitude`. These properties
 * represent the minimum and maximum latitude and longitude values for a map view. The function
 * `getMapCoordinatesQueryString` takes in this object as a parameter
 * @returns The function `getMapCoordinatesQueryString` is returning a string that contains the
 * coordinates of a map. The string is constructed using the values of the `locationParameters` object,
 * which should have properties `minimumLatitude`, `maximumLatitude`, `minimumLongitude`, and
 * `maximumLongitude`. The string is formatted as
 * `coordinates=29.513244482891352,31.014810450257787,-98.90597549023437,-96.57962050976562`.
 */
export const getMapCoordinatesQueryString = (locationParameters) => {

  const mapCoordinatesQueryString =
   `coordinates=${locationParameters?.minimumLatitude},${locationParameters?.minimumLongitude},` +
      `${locationParameters?.maximumLatitude},${locationParameters?.maximumLongitude}`;

  return mapCoordinatesQueryString;
}